import { Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import messages from './messages'

export interface IMoveItemsWarningContentProps {
  /** Selected items whose related items must move together (BHV-023) */
  affectedItems: { item: CreditCardItem; relatedCount: number }[]
  /** Total item count of the confirmed move (selected + related) */
  totalCount: number
}

// Warning-modal CONTENT only — the ModalDialog wrapper and the Dismiss/Move
// buttons are FS-owned (FS-owned-modal command pattern).
export const MoveItemsWarningContent = ({
  affectedItems,
  totalCount,
}: IMoveItemsWarningContentProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space>
      <Text autoMargin={false}>
        {intl.formatMessage(messages.warningIntro, { count: totalCount })}
      </Text>
      <Space size='small'>
        {affectedItems.map(({ item, relatedCount }) => (
          <Space
            key={item.id}
            direction='horizontal'
            justify='space-between'
            align='center'
          >
            <Text autoMargin={false}>{item.descriptionLabel}</Text>
            <Text color='textSecondary' autoMargin={false}>
              {intl.formatMessage(messages.movesWithRelatedItems, {
                count: relatedCount,
              })}
            </Text>
          </Space>
        ))}
      </Space>
    </Space>
  )
}

MoveItemsWarningContent.displayName = 'MoveItemsWarningContent'
